import { InsertLinksHost } from 'owa-attachment-link-common';
import { RibbonButton } from 'owa-editor-ribbonplugin';
import { isFeatureEnabled } from 'owa-feature-flags';
import ItemId from 'owa-service/lib/contract/ItemId';
import getAttachmentPolicy from 'owa-session-store/lib/utils/getAttachmentPolicy';
import { getButtonsWithFilePicker } from './getButtonsWithFilePicker';
import { openFilePickerForInsertLinksHandler } from './openFilePickerForInsertLinksHandler';

export function tryGetButtonsWithFilePicker(
    viewState: InsertLinksHost,
    fromAddress: string,
    upsellClickHandler: () => void,
    referenceItemId: ItemId
): RibbonButton[] | undefined {
    if (
        !(
            isFeatureEnabled('cmp-hyperlinkContextMenu') ||
            isFeatureEnabled('cmp-hyperlinkFileSearch')
        )
    ) {
        return undefined;
    }
    const attachmentPolicy = getAttachmentPolicy();
    if (
        !attachmentPolicy?.ReferenceAttachmentsEnabled ||
        !attachmentPolicy?.AttachmentDataProviderAvailable
    ) {
        return undefined;
    }

    const filePickerContext = {
        insertLinksHost: viewState,
        openFilePickerHandler: openFilePickerForInsertLinksHandler,
        fromAddress: fromAddress,
        upsellClickHandler: upsellClickHandler,
        referenceItemId: referenceItemId,
    };
    return getButtonsWithFilePicker(filePickerContext);
}
